<template>
  <div>
    <el-select
      size="mini"
      placeholder="Tecnico Asignado"
      v-model="TechnicianId"
      filterable
      clearable
      @change="handleTechnicianChange"
    >
      <el-option
        v-for="(item, index) in technicians"
        :key="index"
        :value="item.value"
        :label="item.label"
      />
    </el-select>
    <yearcomponent
      ref="yearC"
      @change="handler_year"
      v-model="year"
    ></yearcomponent>
    <el-select
      v-model="serviceTypeID"
      @change="handlerChangesServices"
      size="mini"
      clearable
      placeholder="Tipo de servicio"
      class="ml-5"
      filterable
    >
      <el-option
        v-for="item in serviceTypeList"
        :key="item.Id"
        :label="item.Description"
        :value="item.Id"
      >
      </el-option>
    </el-select>
    <el-select
      v-model="productId"
      size="mini"
      placeholder="Producto"
      class="ml-5"
      @change="handlerProductChange"
    >
      <el-option
        v-for="item in Preoducts"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <el-select
      v-model="customersercesId"
      @change="handlerChangesCustomerServices"
      size="mini"
      clearable
      placeholder="Servicio al Cliente"
      class="ml-5"
      filterable
    >
      <el-option
        v-for="item in customerserces"
        :key="item.codigoserciEx"
        :label="item.nombre"
        :value="item.codigoserciEx"
      >
      </el-option>
    </el-select>
    <RabbeyTable3
      v-loading="detailTableLoading"
      :columns="columns"
      :data="items"
      :show-summary="true"
      :summary-method="getSummaries"
      style="margin: 20px"
    />
    <el-drawer
      title="Detalla de Solicitudes"
      :visible="drawer"
      size="80%"
      v-loading="drawerLoading"
      :before-close="CloseDetail"
    >
      <h2 style="margin: 20px">
        {{ CustomerName }}
      </h2>
      <RabbeyTable3
        v-loading="detailTableLoading"
        :columns="ColunmsDrawer"
        :data="itemsDrawer"
        style="margin: 20px"
      />
    </el-drawer>
  </div>
</template>

<script>
import ImagePerson from "@/components/functionals/ImagePerson.vue";
import RabbeyTable3 from "@/components/RabbeyTable3.vue";
import InteractionDetailsHyperLink from "@/components/functionals/InteractionDetailsHyperLink.vue";
import yearcomponent from "@/components/Global_System/YearsComponent.vue";
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import { getSummaries } from "@/helpers/TableRabbeyTools";
import HyperlinkForResultsStatus from "@/components/functionals/HyperlinkForResultsStatus";

export default {
  name: "ReportReques",
  components: {
    yearcomponent,
    RabbeyTable3
  },
  data() {
    return {
      serviceTypeList: [],
      technicians: [],
      items: [],
      itemsDrawer: [],
      customerserces: [],
      clientecode: "",
      CustomerName: "",
      TechnicianId: "",
      customersercesId: "",
      year: 2024,
      serviceTypeID: "",
      deparmentId: 0,
      mes: 0,
      drawer: false,
      detailTableLoading: false,
      // serviceTypeID:"",

      columns: [
        {
          prop: "Cliente",
          label: "Cliente",
          minWidth: 260
        },
        {
          prop: "Clasificacion",
          label: "Tipo de cliente",
          minWidth: 155,
          sortable: true
        },
        {
          prop: "Quantity",
          label: "Cantidad de equipos",
          minWidth: 155,
          sortable: true
        },
        {
          prop: "monto",
          label: "Facturacion mensual",
          minWidth: 155,
          formatter: HyperlinkForResultsStatus,
          sortable: true
        },
        {
          prop: "january",
          label: "Enero",
          formatter: InteractionDetailsHyperLink,
          key: 1,
          attrs: {
            openDrawer: this.OpenSalesDitails
          }
        },
        {
          prop: "february",
          label: "Febrero",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenSalesDitails
          }
        },
        {
          prop: "march",
          label: "Marzo",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenSalesDitails
          }
        },
        {
          prop: "april",
          label: "Abril",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenSalesDitails
          }
        },
        {
          prop: "may",
          label: "Mayo",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenSalesDitails
          }
        },
        {
          prop: "june",
          label: "Junio",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenSalesDitails
          }
        },
        {
          prop: "july",
          label: "Julio",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenSalesDitails
          }
        },
        {
          prop: "august",
          label: "Agosto",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenSalesDitails
          }
        },
        {
          prop: "september",
          label: "Septiembre",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenSalesDitails
          }
        },
        {
          prop: "october",
          label: "Octubre",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenSalesDitails
          }
        },
        {
          prop: "november",
          label: "Noviembre",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenSalesDitails
          }
        },
        {
          prop: "december",
          label: "Diciembre",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenSalesDitails
          }
        },
        {
          prop: "total",
          label: "Total"
        }
      ],
      ColunmsDrawer: [
        {
          prop: "Name",
          label: "Cliente",
          minWidth: 155
        },
        {
          prop: "Comments",
          label: "Descripcion",
          minWidth: 300
        },
        {
          prop: "tipodescription",
          label: "Tipo de solicitud",
          minWidth: 155
        },
        {
          prop: "CreatedAt",
          label: "Fecha de Creacion",
          formatter: DatetimeFormatter,
          minWidth: 155
        },
        {
          prop: "responsableName",
          label: "Tecnigo Asignado",
          formatter: ImagePerson,
          attrs: {
            imgKey: "imageUrl"
          },
          minWidth: 155
        },
        {
          prop: "creartor",
          label: "Creado por",
          minWidth: 155,
          formatter: ImagePerson,
          attrs: {
            imgKey: "imagecreator"
          }
        },
        {
          prop: "ServiceRequestCloseDate",
          label: "Fecha de cierre",
          formatter: DatetimeFormatter,

          minWidth: 155
        },
        {
          prop: "Status",
          label: "Estatus",
          minWidth: 155
        }
      ],
      productId: "",
      Preoducts: [
        {
          label: "Terminales",
          value: 1
        },
        {
          label: "GPS",
          value: 2
        },
        {
          label: "Todos",
          value: 0
        }
      ]
    };
  },
  methods: {
    getSummaries,

    handleTechnicianChange(technician) {
      this.TechnicianId = technician;
      this.GetReportServiceRequests();
    },
    handler_year(_year) {
      this.year = _year;
      this.GetReportServiceRequests();
    },
    handlerChangesServices(_Service) {
      this.serviceTypeID = _Service;
      this.GetReportServiceRequests();
    },
    handleChangeDeparment(deparmentId) {
      this.deparmentId = deparmentId;
    },
    CloseDetail() {
      this.drawer = false;
    },
    OpenSalesDitails(row, column) {
      this.clientecode = row.Id;
      this.CustomerName = row.Cliente;
      this.mes = this.getMonthNumber(column);
      this.GetReportServiceRequestsDetails();
      this.drawer = true;
    },
    handlerChangesCustomerServices(codecustometservices) {
      this.customersercesId = codecustometservices;
      this.GetReportServiceRequests();
    },
    GetReportServiceRequests() {
      this.$http
        .get("/api/serviceRequests/GetReportServiceRequests", {
          params: {
            YearFilter: this.year,
            CustomerServiceExecFilter: this.customersercesId,
            AssignedTechnicianIdFilter: this.TechnicianId,
            ServiceRequestTypeId: this.serviceTypeID,
            ProdutId: this.productId
          }
        })
        .then((resp) => {
          this.items = resp.data;
        });
    },

    getMonthNumber(month) {
      switch (month) {
        case "january":
          return 1;
        case "february":
          return 2;
        case "march":
          return 3;
        case "april":
          return 4;
        case "may":
          return 5;
        case "june":
          return 6;
        case "july":
          return 7;
        case "august":
          return 8;
        case "september":
          return 9;
        case "october":
          return 10;
        case "november":
          return 11;
        case "december":
          return 12;
      }
    },
    GetReportServiceRequestsDetails() {
      this.$http
        .get("/api/serviceRequests/GetReportServiceRequestsDetails", {
          params: {
            YearFilter: this.year,
            CustomerServiceExecFilter: this.customersercesId,
            AssignedTechnicianIdFilter: this.TechnicianId,
            ServiceRequestTypeId: this.serviceTypeID,
            ClientCode: this.clientecode,
            mes: this.mes
          }
        })
        .then((resp) => {
          this.itemsDrawer = resp.data;
        });
    },
    getServicesTypes() {
      this.$http
        .get("/api/serviceRequestTypes/ServiceRequestTypesList", {})
        .then((resp) => {
          this.serviceTypeList = resp.data;
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    getCustomerServices() {
      this.$http("/api/serviceRequests/GetCustomersServices").then((resp) => {
        this.customerserces = resp.data;
      });
    },
    handlerProductChange() {
      this.GetReportServiceRequests();
    }
  },
  created() {
    this.getCustomerServices();
    this.GetReportServiceRequests();
    this.getServicesTypes();
    this.$http.get("/api/users/technicians").then((resp) => {
      this.technicians = resp.data;
    });
  }
};
</script>
